import { getCookie, setCookie } from '@beef/utils';
var MOBILE_VIEW_COOKIE = 'mobileViewCookie';
export var getIsWebview = function getIsWebview() {
  var cookieDomain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (typeof window === 'undefined') {
    return false;
  }
  var search = new URLSearchParams(window.location.search.toLowerCase());
  var isWebViewInUrl = search.get('webview') === 'true' || search.get('webview') === 'true/';
  var isWebViewInCookie = !!getCookie(MOBILE_VIEW_COOKIE);
  var isWebViewParams = isWebViewInUrl || isWebViewInCookie;
  var userAgent = typeof navigator !== 'undefined' && navigator.userAgent ? navigator.userAgent : '';
  var normalizedUserAgent = userAgent.toLowerCase();
  var isIos = /ip(ad|hone)/.test(normalizedUserAgent);
  var isAndroid = /android/.test(normalizedUserAgent);
  if (cookieDomain && isWebViewInUrl && !isWebViewInCookie) {
    setCookie({
      name: MOBILE_VIEW_COOKIE,
      value: 'true',
      domain: cookieDomain
    });
  }
  return isWebViewParams && (isAndroid || isIos);
};